"use client";

import Picture1 from "../images/must-experience/azerbaijan-img-1.jpg";
import Picture2 from "../images/must-experience/azerbaijan-img-2.jpg";
import Picture3 from "../images/must-experience/azerbaijan-img-3.jpg";
import Picture4 from "../images/must-experience/azerbaijan-img-4.jpg";
import Picture5 from "../images/must-experience/azerbaijan-img-5.jpg";
import Picture6 from "../images/must-experience/azerbaijan-img-6.jpg";
import Picture7 from "../images/must-experience/azerbaijan-img-7.jpg";
import Picture8 from "../images/must-experience/azerbaijan-img-8.jpg";
import Picture9 from "../images/must-experience/azerbaijan-img-9.jpg";
import Picture10 from "../images/must-experience/azerbaijan-img-10.jpg";
import Picture11 from "../images/must-experience/azerbaijan-img-11.jpg";

import Car from "@/public/svg/destinations/hand-picked/car.svg";
import Building from "@/public/svg/destinations/hand-picked/building.svg";
import Activity from "@/public/svg/destinations/hand-picked/activity.svg";
import Dot from "@/public/svg/destinations/hand-picked/dot.svg";
import Visa from "@/public/svg/destinations/hand-picked/visa.svg";
import food from "@/public/svg/destinations/hand-picked/all-board.svg"

import Iconpicture from "@/public/png/common/group-tour/all-premium-inclusive.svg";

import HorizontalTicketCard from "@/components/horizontal-ticket-card-for-group-tour-date/ticket-card";

import Title from "@/components/title/Title";

import "@/styles/common/swiper.scss";
import "swiper/scss/navigation";
import "swiper/scss/pagination";
import "swiper/scss";

import "@/sections/common/horizontal-card/horizontal-card.scss";

const Honeymoon = [

    {
        name: "3N Cultural Gateway Azerbaijan Tour Package from Kerala",
        picture: Picture1,
        location: "3N Baku",
        price: "₹31,999",
        type: "4 days",
        iconpicture:Iconpicture,
        link :"#hero",
        list: [
            {
                icon: Building,
                title: "Accommodations",
            },
            {
                icon: Activity,
                title: "Sightseeings",
            },
            {
                icon: food,
                title: "Breakfast",
            },
            {
                icon: Car,
                title: "Transfers",
            },
            {
                icon: Visa,
                title: "Visa",
            },
        ],

        listvertical: [
            {
                icon: Dot,
                title: "Walk down vibrant Nizami Street & Fountain Square",
            },
            {
                icon: Dot,
                title: "Explore the historic Old City of Baku: Maiden Tower, Karavansarays & Palace of the Shirvanshahs",
            },
            {
                icon: Dot,
                title: "Enjoy the Gobustan Tour featuring the Mud Museum & Mud Volcano",
            },
           
        ],
        trends: [
            {
                title: "4 days",
                color: "#d0cece",
            },
        ],
        mostbook: [
            {
                title: "Highly Popular",
                color: "#25d366",
            },
        ],
    },
    {
        name: "City Explorer Azerbaijan Travel Package from Kerala – 3N Baku Highlights",
        picture: Picture2,
        location: "3N Baku",
        price: "₹38,999",
        type: "4 days",
        iconpicture:Iconpicture,
        link :"#hero",
        list: [
            {
                icon: Building,
                title: "Accommodations",
            },
            {
                icon: Activity,
                title: "Sightseeings",
            },
            {
                icon: food,
                title: "Breakfast",
            },
            {
                icon: Car,
                title: "Transfers",
            },
            {
                icon: Visa,
                title: "Visa",
            },
        ],
    
        listvertical: [
            {
                icon: Dot,
                title: "Visit the Miniature Book Museum & Juma Mosque",
            },
            {
                icon: Dot,
                title: "Stroll along Baku Boulevard & enjoy panoramic views from Baku Eye",
            },
            {
                icon: Dot,
                title: "Old City Tour + Gobustan Tour with Mud Complex, Museum & Volcano",
            },
            {
                icon: Dot,
                title: "See the spiritual Bibiheybat Mosque",
            },
        ],
        trends: [
            {
                title: "4 days",
                color: "#d0cece",
            },
        ],
        mostbook: [
            {
                title: "Highly Popular",
                color: "#25d366",
            },
        ],
    }, 
    {
        name: "Iconic Landmarks Azerbaijan Holiday Package from Kerala – 3N Baku",
        picture: Picture3,
        location: "3N Baku",
        price: "₹32,999",
        type: "4 days",
        iconpicture:Iconpicture,
        link :"#hero",
        list: [
            {
                icon: Building,
                title: "Accommodations",
            },
            {
                icon: Activity,
                title: "Sightseeings",
            },
            {
                icon: food,
                title: "Breakfast",
            },
            {
                icon: Car,
                title: "Transfers",
            },
            {
                icon: Visa,
                title: "Visa",
            },
        ],
    
        listvertical: [
            {
                icon: Dot,
                title: "Visit the famous Ateshgah Temple & Burning Mountain (Yanar Dag)",
            },
            {
                icon: Dot,
                title: "Photo stop at the futuristic Heydar Aliyev Center",
            },
            {
                icon: Dot,
                title: "Explore Baku Eye, Carpet Museum, Little Venice, & Upland Park",
            },
        ],
        trends: [
            {
                title: "4 days",
                color: "#d0cece",
            },
        ],
        mostbook: [
            {
                title: "Highly Popular",
                color: "#25d366",
            },
        ],
    },
    {
        name: "Mountain & Culture Combo – 4N Azerbaijan Tour Package from Kerala",
        picture: Picture4,
        location: "3N Baku + 1N Gabala",
        price: "₹42,999",
        type: "5 days",
        iconpicture:Iconpicture,
        link :"#hero",
        list: [
            {
                icon: Building,
                title: "Accommodations",
            },
            {
                icon: Activity,
                title: "Sightseeings",
            },
            {
                icon: food,
                title: "Breakfast",
            },
            {
                icon: Car,
                title: "Transfers",
            },
            {
                icon: Visa,
                title: "Visa",
            },
        ],
    
        listvertical: [
            {
                icon: Dot,
                title: "Enjoy a cable car ride at Tufandag Mountain",
            },
            {
                icon: Dot,
                title: "Discover Nohur Lake & Seven Beauties Waterfalls",
            },
            {
                icon: Dot,
                title: "Visit Gobustan (Mud Museum & Mud Volcano)",
            },
            {
                icon: Dot,
                title: "Explore Baku: Baku Eye, Carpet Museum, and Little Venice",
            },
        ],
        trends: [
            {
                title: "5 days",
                color: "#d0cece",
            },
        ],
        mostbook: [
            {
                title: "Highly Popular",
                color: "#25d366",
            },
        ],
    },
    {
        name: "Balanced Bliss Azerbaijan Trip Package from Kerala – 4N Baku & Gabala",
        picture: Picture5,
        location: "2N Baku + 2N Gabala",
        price: "₹44,999",
        type: "5 days",
        iconpicture:Iconpicture,
        link :"#hero",
        list: [
            {
                icon: Building,
                title: "Accommodations",
            },
            {
                icon: Activity,
                title: "Sightseeings",
            },
            {
                icon: food,
                title: "Breakfast",
            },
            {
                icon: Car,
                title: "Transfers",
            },
            {
                icon: Visa,
                title: "Visa",
            },
        ],
    
        listvertical: [
            {
                icon: Dot,
                title: "Full Gabala Tour with Tufandag Mountain, Nohur Lake & Waterfalls",
            },
            {
                icon: Dot,
                title: "Discover Baku with Miniature Book Museum, Juma Mosque, Baku Boulevard, & Baku Eye",
            },
            {
                icon: Dot,
                title: "Take the Absheron Tour: Ateshgah Temple & Burning Mountain",
            },
        ],
        trends: [
            {
                title: "5 days",
                color: "#d0cece",
            },
        ],
        mostbook: [
            {
                title: "Highly Popular",
                color: "#25d366",
            },
        ],
    },
    {
        name: "Extended Escape – 5N Azerbaijan Holiday Package from Kerala",
        picture: Picture6,
        location: "4N Baku + 1N Gabala",
        price: "₹51,999",
        type: "6 days",
        iconpicture:Iconpicture,
        link :"#hero",
        list: [
            {
                icon: Building,
                title: "Accommodations",
            },
            {
                icon: Activity,
                title: "Sightseeings",
            },
            {
                icon: food,
                title: "Breakfast",
            },
            {
                icon: Car,
                title: "Transfers",
            },
            {
                icon: Visa,
                title: "Visa",
            },
        ],
    
        listvertical: [
            {
                icon: Dot,
                title: "Gabala Tour: Tufandag Mountain, Nohur Lake & Waterfalls",
            },
            {
                icon: Dot,
                title: "In Baku: Book Museum, Juma Mosque, Boulevard & Baku Eye",
            },
            {
                icon: Dot,
                title: "Absheron Excursion with Ateshgah & Yanar Dag",
            },
        ],
        trends: [
            {
                title: "6 days",
                color: "#d0cece",
            },
        ],
        mostbook: [
            {
                title: "Highly Popular",
                color: "#25d366",
            },
        ],
    },
    {
        name: "Grand Heritage – 5N Azerbaijan Tour from Kerala with Sheki Experience",
        picture: Picture7,
        location: "3N Baku + 1N Gabala + 1N Sheki",
        price: "₹63,999",
        type: "6 days",
        iconpicture:Iconpicture,
        link :"#hero",
        list: [
            {
                icon: Building,
                title: "Accommodations",
            },
            {
                icon: Activity,
                title: "Sightseeings",
            },
            {
                icon: food,
                title: "Breakfast",
            },
            {
                icon: Car,
                title: "Transfers",
            },
            {
                icon: Visa,
                title: "Visa",
            },
        ],
    
        listvertical: [
            {
                icon: Dot,
                title: "Gabala: Mountain cable car, waterfalls, and scenic lake views",
            },
            {
                icon: Dot,
                title: "Baku City Tour + Absheron Tour",
            },
            {
                icon: Dot,
                title: "Discover Sheki: Sheki Khan Palace, Karavansaray, and Panorama Park",
            },
        ],
        trends: [
            {
                title: "6 days",
                color: "#d0cece",
            },
        ],
        mostbook: [
            {
                title: "Highly Popular",
                color: "#25d366",
            },
        ],
    },
    {
        name: "Ultimate Azerbaijan Tour Package from Kerala – 7N Cultural Journey",
        picture: Picture8,
        location: "5N Baku + 1N Gabala + 1N Sheki",
        price: "₹63,999",
        type: "8 days",
        iconpicture:Iconpicture,
        link :"#hero",
        list: [
            {
                icon: Building,
                title: "Accommodations",
            },
            {
                icon: Activity,
                title: "Sightseeings",
            },
            {
                icon: food,
                title: "Breakfast",
            },
            {
                icon: Car,
                title: "Transfers",
            },
            {
                icon: Visa,
                title: "Visa",
            },
        ],
    
        listvertical: [
            {
                icon: Dot,
                title: "Explore Baku: City tour, Gobustan, Absheron Circuit & more",
            },
            {
                icon: Dot,
                title: "Gabala Tour with lake, cable car & waterfalls",
            },
            {
                icon: Dot,
                title: "Dive into history with a full Sheki Heritage Tour",
            },
        ],
        trends: [
            {
                title: "8 days",
                color: "#d0cece",
            },
        ],
        mostbook: [
            {
                title: "Highly Popular",
                color: "#25d366",
            },
        ],
    }
    
];

const HorizontalCard = () => {
    return (
        <section className="horizontal-card-section py-10 md:py-20">
            <div className="horizontal-card-container container px-4 flex flex-col mx-auto gap-6 sm:gap-14">
                <Title title="Best Azerbaijan Tour Packages from Kerala for Every Traveler" />
                <div className="horizontal-card-wrapper flex flex-col gap-14">
                    {Honeymoon.map((h, index) => {
                        return <HorizontalTicketCard key={index} {...h} />;
                    })}
                </div>
            </div>
        </section>
    );
};

export default HorizontalCard;
